export const cleanUpPayload = (payload) => {
  const result = { ...payload };
  //delete result['id']
  delete result['idx']
  delete result['user']
  return result
}

export const crudActions = (BASE_URL, BASE_URL_PUBLIC = null) => {
  if (!BASE_URL_PUBLIC) BASE_URL_PUBLIC = BASE_URL
  return {
    async fetchObjects({ commit }, params = {}) {
      const response = await this.$axios.$get(BASE_URL_PUBLIC, { params: params })
      commit('SET_OBJECTS', { objects: response['items'], total: response['total'] })
      return response
    },
    async fetchObject({}, id) {
      return this.$axios.$get(`${BASE_URL_PUBLIC}${id}/`)
    },
    async createObject({}, payload) {
      const response = await this.$axios.$post(BASE_URL, payload)

      return { ...response }
    },
    async updateObject({ commit }, { payload, id }) {
      const response = await this.$axios.$post(`${BASE_URL}${id}/`, cleanUpPayload(payload))

      commit('UPDATE_OBJECT', response)
      return response
    },
    async deleteObject({ commit }, id) {
      const response = await this.$axios.$delete(`${BASE_URL}${id}/`)

      if (response.ok) {
        commit('DELETE_OBJECT', id)
      }
      return response.ok
    },
  }
}

export const crudMutations = {
  SET_OBJECTS(state, payload) {
    state.objects = payload.objects.map(x => {
      x.key = x.idx
      return x
    });
    state.total = payload.total;
  },
  UPDATE_OBJECT(state, payload) {
    state.objects = [...state.objects.map(x => {
      if (x.id === payload.id) {
        return payload
      }
      return x
    })];
  },
  DELETE_OBJECT(state, id) {
    state.objects = state.objects.filter(obj => obj.id !== id )
  }
}

export const crudGetters = {
  getObjects: (state) => {
    return state.objects
  }
}
